import React, { useState } from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './pages/Home';
import TwilioControlPanel from './pages/TwilioControlPanel';
import PasswordGate from './components/auth/PasswordGate';
import './App.css';

function App() {
  // Initialize auth state from session storage to persist across refreshes
  const [isAuthenticated, setIsAuthenticated] = useState(() => {
    return sessionStorage.getItem('gyso_admin_authed') === '1';
  });

  if (!isAuthenticated) {
    return <PasswordGate onLogin={() => setIsAuthenticated(true)} />;
  }

  return (
    <Router>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/twilio/*" element={<TwilioControlPanel />} />
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;